document.addEventListener( 'DOMContentLoaded', function () {
    // Dynamically select fields based on the "billing_postcode_*" class (customly set in the custom fields)
    const postcodeDivs = document.querySelectorAll( 'form [class*="billing-postcode-"]' );
    const fields = {};

    // Push all the fields into an array with custom key
    postcodeDivs.forEach( ( node ) => {
        // Extract the class after 'billing-postcode-'
        const className = Array.from( node.classList ).find( cls => cls.startsWith( 'billing-postcode-' ) );
        if ( className ) {

            const key = className.replace( 'billing-postcode-', '' ); // Remove 'billing_postcode_' prefix
            fields[ key ] = node; // Add the field to the array
        }
    } );

    // Assign specific fields from the dynamically created variables
    const sourcefieldBillingCity = fields['city'];
    const sourcefieldBillingCountry = fields['country'];
    const sourcefieldBillingHouseNumber = fields['house-number'];
    const sourcefieldBillingPostcode = fields['postcode'];
    const sourcefieldBillingStreet = fields['street'];

    // Check if all necessary fields exist
    if ( sourcefieldBillingCity && sourcefieldBillingCountry && sourcefieldBillingHouseNumber && sourcefieldBillingPostcode && sourcefieldBillingStreet ) {

        let debounceTimeout;
        const updateTargetField = () => {

            // Clear the input of the given fields
            const postcodeValue = sourcefieldBillingPostcode.value.trim();
            const houseNumberValue = sourcefieldBillingHouseNumber.value.trim();

            // Clear any existing timeout
            clearTimeout( debounceTimeout );

            // Set a new timeout for 1 seconds, so we wont overload the API
            debounceTimeout = setTimeout( async () => {

                // If postcode and number has value
                if ( postcodeValue && houseNumberValue ) {

                    // Get the response from the API
                    var address = await autoFillAddress( postcodeValue, houseNumberValue );
                    if ( address ) {

                        // Reset the street and city fields
                        sourcefieldBillingStreet.value = address?.street;
                        sourcefieldBillingCity.value = address?.city;
                    }
                }
            }, 1000);
        };

        // Attach the input event listener to the relevant fields
        sourcefieldBillingPostcode.addEventListener( 'input', updateTargetField );
        sourcefieldBillingHouseNumber.addEventListener( 'input', updateTargetField );
    }
} );